import { Card, CardContent, Stack, Typography } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { T_MANY } from '../../constants';
import { GroupChipElement } from '../group-chip-element';
import { ResponsiveText } from '../responsive-text';
import { DataRow } from '../static-data/data-row';

interface Props {
  'data-testid'?: string;
  groupIds: string[];
  isClickable?: boolean;
  noGroupsText: string;
}

export const GroupsCard: FC<Props> = ({ groupIds, isClickable = false, noGroupsText, ...props }) => {
  const { t } = useTranslation(['common']);

  const titleText = t('common:terms.group', { count: T_MANY });

  return <Card data-testid={props['data-testid']} style={{ height: 'min-content' }}>
    <CardContent>
      <Stack spacing={2}>
        <ResponsiveText
          variant="h5"
          color="text.primary"
          responsiveOptions={{
            minFontSize: '1.25rem',
            maxFontSize: '1.5rem',
            textLengthThreshold: 25,
          }}
        >
          {titleText}
        </ResponsiveText>
        {!groupIds.length
          ? <Typography fontStyle="italic" color="text.secondary" variant="body2">
            {noGroupsText}
          </Typography>
          : <DataRow value={<GroupChipElement groupIds={groupIds} isClickable={isClickable} />} />
        }
      </Stack>
    </CardContent>
  </Card>;
};
